const RESET_STATE = 'newHireStatuses/RESET_STATE'
const UPDATE_FILTER = 'newHireStatuses/UPDATE_FILTER'
const UPDATE_SELECTED = 'newHireStatuses/UPDATE_SELECTED'

export const actions = {
  RESET_STATE,
  UPDATE_FILTER,
  UPDATE_SELECTED
}

export const statuses = [
  { id: '8', name: 'Hired: Onboarding' },
  { id: '9', name: 'Hired: Completed' }
]

export const initialState = {
  filter: { text: '' },
  filteredIds: statuses.map((x) => x.id.toString()),
  loading: false,
  selected: [],
  statuses
}

const lowCase = (str) => str.toLowerCase()
export function filterItems({ items, filter }) {
  const { text } = filter
  const query = lowCase(text)
  const matchesQuery = (x) => lowCase(x.name).includes(query)
  return items.filter(matchesQuery).map((x) => x.id.toString())
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_FILTER:
      const { filter, value } = action
      const newFilter = {
        text: filter === 'text' ? value : state.filter.text
      }
      return {
        ...state,
        filter: newFilter,
        filteredIds: filterItems({ items: state.statuses, filter: newFilter })
      }
    case UPDATE_SELECTED:
      return {
        ...state,
        selected: action.ids
      }
    case RESET_STATE:
      return {
        ...initialState,
        statuses: state.statuses,
        filteredIds: state.statuses.map((x) => x.id)
      }
    default:
      return state
  }
}

export default reducer

export function updateSelected(ids) {
  return {
    type: UPDATE_SELECTED,
    ids
  }
}

export function updateFilter({ filter, value }) {
  return {
    type: UPDATE_FILTER,
    filter,
    value
  }
}

export function resetState() {
  return { type: RESET_STATE }
}



// WEBPACK FOOTER //
// ./src/modules/Forms/reducers/newHireStatuses.js